import fetch from 'isomorphic-fetch';
import qs from 'qs';

export function stringifyGET(url, data) {
  const query = Object.keys(data).reduce((q, key) => {
    if (data[key] !== null) {
      return q + '&' + encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }
    return q;
  }, '');

  if (query) {
    url += (~url.indexOf('?') ? '&' : '?') + query.substring(1);
  }
  return url;
}

export function stringifyGETUnencoded(url, data) {
  const query = Object.keys(data).reduce((q, key) => {
    if (data[key] !== null) {
      return q + '&' + key + '=' + data[key];
    }
    return q;
  }, '');

  if (query) {
    url += (~url.indexOf('?') ? '&' : '?') + query.substring(1);
  }
  return url;
}

export function http(method, url, data, headers = {}, useCredentials = false) {
  method = method.toUpperCase();

  const request = {
    method: method,
    headers: Object.assign(
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      headers
    ),
  };

  if (useCredentials) {
    request.credentials = 'include';
  }

  if (data) {
    data = Object.assign({}, data);
    if (method === 'GET' || method === 'DELETE') {
      url = stringifyGET(url, data);
    } else if (method === 'POST' || method === 'PUT') {
      request.body = JSON.stringify(data);
    }
  }

  return fetch(url, request).then(handleResponse);
}

// ------------------------------------------------------------

function handleResponse(response = {}) {
  if (response.status === 200) {
    return response.json();
  } else {
    return response.json();
  }
}

export function getQueryParam(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

export function getQueryParamWithHash(name) {
  let hash = window.location.hash;

  if (!hash || hash.indexOf('?') < 0) {
    return {};
  }

  let queryIndex = hash.indexOf('?'),
    queryString = hash.substr(queryIndex + 1, hash.length);

  const params = qs.parse(queryString);

  return params[name];
}

export function getQueryParamNoHash(name) {
  let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
